// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      display: block;
      width: 100%;
    }

    /* ══════════════════════════════════════════
       MOBILE COMPACT BAR
       ══════════════════════════════════════════ */

    .mobile-compact-bar {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      width: 100%;
      flex-wrap: nowrap;
    }

    /* Compact dropdowns */
    .compact-dropdown {
      flex: 1;
      min-width: 0;
      display: flex;
    }

    .compact-dropdown .dropdown-btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.25rem;
      font-size: 0.775rem;
      font-weight: 500;
      padding: 0.45rem 0.625rem;
      border-radius: 8px;
      border: 1.5px solid #ede9fb;
      background: #faf8ff;
      color: #374151;
      white-space: nowrap;
      transition: all 0.2s;
      min-width: 0;
    }

    .compact-dropdown .dropdown-btn:active {
      background: #f3eeff;
      border-color: #c4b5fd;
      color: #7c3aed;
    }

    .compact-dropdown .dropdown-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      min-width: 0;
    }

    /* Balance chip */
    .balance-chip {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #f5f3ff;
      border: 1.5px solid #ede9fb;
      border-radius: 8px;
      padding: 0.35rem 0.625rem;
      flex-shrink: 0;
      cursor: pointer;
      transition: background 0.2s;
      -webkit-tap-highlight-color: transparent;
    }

    .balance-chip:active {
      background: #ede9fb;
    }

    .balance-chip small {
      font-size: 0.6rem;
      color: #7c6fa0;
      text-transform: uppercase;
      font-weight: 600;
      letter-spacing: 0.4px;
      line-height: 1;
    }

    .balance-chip span {
      font-size: 0.82rem;
      font-weight: 700;
      color: #1a003d;
      line-height: 1.35;
    }

    /* Compact top-up button */
    .topup-btn-compact {
      background: linear-gradient(135deg, #7c3aed, #a78bfa);
      color: #ffffff;
      border: none;
      border-radius: 8px;
      padding: 0.45rem 0.875rem;
      font-size: 0.8rem;
      font-weight: 600;
      letter-spacing: 0.3px;
      cursor: pointer;
      flex-shrink: 0;
      transition: opacity 0.2s, transform 0.15s;
      -webkit-tap-highlight-color: transparent;
      white-space: nowrap;
    }

    .topup-btn-compact:active {
      opacity: 0.85;
      transform: scale(0.96);
    }

    /* Shared dropdown menu */
    .dropdown-menu-custom {
      min-width: 180px;
      padding: 0.5rem 0;
      border: 1.5px solid #f0eafa;
      box-shadow: 0 4px 16px rgba(109, 40, 217, 0.1);
      border-radius: 10px;
    }

    .dropdown-item-custom {
      padding: 0.625rem 1rem;
      border: none;
      background: none;
      text-align: left;
      width: 100%;
      cursor: pointer;
      transition: background-color 0.2s ease;
      font-size: 0.875rem;
      color: #374151;
    }

    .dropdown-item-custom:hover {
      background-color: #f5f3ff;
      color: #7c3aed;
    }

    /* ══════════════════════════════════════════
       FULL (DESKTOP / ORIGINAL) LAYOUT
       ══════════════════════════════════════════ */

    .user-info-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
    }

    .user-info-container {
      display: flex;
      align-items: center;
      gap: 1.25rem;
      width: 100%;
    }

    .user-info-container.mobile-layout {
      flex-direction: column;
      align-items: stretch;
      gap: 1.5rem;
    }

    .divider {
      width: 1px;
      height: 32px;
      background: #e5e7eb;
      flex-shrink: 0;
    }

    .divider-main {
      height: 40px;
      background: #d1d5db;
    }

    .notification-section {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .notification-icon {
      color: #7c3aed;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .notification-icon:hover {
      color: #6d28d9;
    }

    .dropdown-section {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }

    .dropdown-btn {
      padding: 0.5rem 1rem;
      white-space: nowrap;
      font-size: 0.875rem;
      font-weight: 500;
      letter-spacing: 0.3px;
      border-radius: 8px;
      transition: all 0.2s ease;
    }

    .balance-section {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }

    .balance-content {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    .balance-labels {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    .balance-label {
      font-size: 0.75rem;
      color: #6b7280;
      font-weight: 500;
      letter-spacing: 0.3px;
      text-transform: uppercase;
    }

    .balance-value {
      font-size: 0.9rem;
      font-weight: 600;
      color: #1a003d;
    }

    .balance-refresh {
      cursor: pointer;
      font-size: 1.1rem;
      transition: transform 0.3s ease, color 0.2s ease;
      color: #7c3aed;
    }

    .balance-refresh:hover {
      transform: rotate(180deg);
      color: #6d28d9;
    }

    .credit-limit-label {
      font-size: 0.7rem;
      color: #f97316;
      font-weight: 600;
      letter-spacing: 0.2px;
    }

    .credit-label {
      font-size: 0.55rem;
      color: #f97316;
      font-weight: 600;
      letter-spacing: 0.3px;
      line-height: 1;
    }

    .topup-section {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }

    .topup-btn {
      padding: 0.5rem 1.25rem;
      font-weight: 600;
      font-size: 0.875rem;
      letter-spacing: 0.3px;
      border-radius: 8px;
      transition: all 0.2s ease;
    }

    .topup-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(124, 58, 237, 0.15);
    }

    .user-profile-section {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-shrink: 0;
      margin-left: auto;
    }

    .mobile-layout .user-profile-section {
      margin-left: 0;
      padding: 0.75rem;
      background: #faf8ff;
      border-radius: 8px;
    }

    .profile-text {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 0.25rem;
    }

    .mobile-layout .profile-text {
      align-items: flex-start;
    }

    .profile-name {
      font-size: 0.9rem;
      font-weight: 600;
      color: #1a003d;
      letter-spacing: 0.2px;
    }

    .profile-role {
      font-size: 0.75rem;
      color: #9ca3af;
      font-weight: 500;
      text-transform: capitalize;
    }

    .mobile-menu {
      position: absolute;
      top: calc(100% + 8px);
      right: 1rem;
      padding: 1.5rem;
      background: #ffffff;
      border: 1.5px solid #f0eafa;
      border-radius: 12px;
      z-index: 1000;
      width: calc(100% - 2rem);
      max-width: 320px;
      box-shadow: 0 8px 32px rgba(109, 40, 217, 0.12);
    }

    .mobile-menu-toggle {
      padding: 0.25rem 0.5rem;
      border: none;
      background: transparent;
    }

    .avatar-circle {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: linear-gradient(135deg, #7c3aed 0%, #f97316 100%);
      flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(124, 58, 237, 0.35);
    }

    .avatar-initials {
      font-family: 'DM Sans', 'Segoe UI', sans-serif;
      font-size: 0.8125rem;
      font-weight: 700;
      color: #ffffff;
      letter-spacing: 0.03em;
      text-transform: uppercase;
      line-height: 1;
      -webkit-user-select: none;
              user-select: none;
    }

    /* Modal */
    .modal-header-custom {
      background: #f5f3ff;
      padding: 1rem 1.5rem;
      border-bottom: 1px solid #ede9fb;
      display: flex;
      justify-content: flex-end;
    }

    .modal-body-custom {
      padding: 3rem 2rem;
      background: #ffffff;
    }

    .modal-title {
      font-size: 1.75rem;
      font-weight: 700;
      color: #2d1b69;
      text-align: center;
      margin-bottom: 0.5rem;
      letter-spacing: -0.5px;
    }

    .modal-subtitle {
      font-size: 1rem;
      color: #7c5ba8;
      text-align: center;
      margin-bottom: 2rem;
      font-weight: 500;
    }

    .modal-instructions {
      display: flex;
      justify-content: center;
    }

    .instructions-list {
      list-style: decimal;
      padding-left: 1.5rem;
      max-width: 480px;
      width: 100%;
    }

    .instructions-list li {
      color: #374151;
      margin-bottom: 1rem;
      line-height: 1.6;
      font-size: 0.95rem;
    }

    .instructions-list .fw-bold {
      color: #7c3aed;
      font-weight: 600;
    }

    @media (max-width: 768px) {
      .modal-body-custom { padding: 2rem 1.5rem; }
      .modal-title { font-size: 1.5rem; }
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/units/zikata-user-info/zikata-user-info.component.ts"],"names":[],"mappings":";IACI;MACE,cAAc;MACd,WAAW;IACb;;IAEA;;mDAE+C;;IAE/C;MACE,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,iBAAiB;IACnB;;IAEA,sBAAsB;IACtB;MACE,OAAO;MACP,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,yBAAyB;MACzB,kBAAkB;MAClB,2BAA2B;MAC3B,mBAAmB;MACnB,cAAc;MACd,mBAAmB;MACnB,oBAAoB;MACpB,YAAY;IACd;;IAEA;MACE,mBAAmB;MACnB,qBAAqB;MACrB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,OAAO;MACP,YAAY;IACd;;IAEA,iBAAiB;IACjB;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;MACnB,2BAA2B;MAC3B,kBAAkB;MAClB,yBAAyB;MACzB,cAAc;MACd,eAAe;MACf,2BAA2B;MAC3B,wCAAwC;IAC1C;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;MACjB,cAAc;MACd,yBAAyB;MACzB,gBAAgB;MAChB,qBAAqB;MACrB,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;MACd,iBAAiB;IACnB;;IAEA,0BAA0B;IAC1B;MACE,qDAAqD;MACrD,cAAc;MACd,YAAY;MACZ,kBAAkB;MAClB,yBAAyB;MACzB,iBAAiB;MACjB,gBAAgB;MAChB,qBAAqB;MACrB,eAAe;MACf,cAAc;MACd,yCAAyC;MACzC,wCAAwC;MACxC,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,sBAAsB;IACxB;;IAEA,yBAAyB;IACzB;MACE,gBAAgB;MAChB,iBAAiB;MACjB,2BAA2B;MAC3B,8CAA8C;MAC9C,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;MACtB,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,WAAW;MACX,eAAe;MACf,sCAAsC;MACtC,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,yBAAyB;MACzB,cAAc;IAChB;;IAEA;;mDAE+C;;IAE/C;MACE,aAAa;MACb,mBAAmB;MACnB,WAAW;IACb;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,WAAW;IACb;;IAEA;MACE,sBAAsB;MACtB,oBAAoB;MACpB,WAAW;IACb;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;IAChB;;IAEA;MACE,cAAc;MACd,eAAe;MACf,2BAA2B;IAC7B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB;MAChB,qBAAqB;MACrB,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,gDAAgD;MAChD,cAAc;IAChB;;IAEA;MACE,yBAAyB;MACzB,cAAc;IAChB;;IAEA;MACE,iBAAiB;MACjB,cAAc;MACd,gBAAgB;MAChB,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,qBAAqB;MACrB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,qBAAqB;MACrB,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;MACE,2BAA2B;MAC3B,+CAA+C;IACjD;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,cAAc;MACd,iBAAiB;IACnB;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;MAClB,qBAAqB;MACrB,WAAW;MACX,eAAe;MACf,mBAAmB;MACnB,2BAA2B;MAC3B,mBAAmB;MACnB,aAAa;MACb,wBAAwB;MACxB,gBAAgB;MAChB,+CAA+C;IACjD;;IAEA;MACE,uBAAuB;MACvB,YAAY;MACZ,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,6DAA6D;MAC7D,cAAc;MACd,8CAA8C;IAChD;;IAEA;MACE,8CAA8C;MAC9C,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,sBAAsB;MACtB,yBAAyB;MACzB,cAAc;MACd,yBAAiB;cAAjB,iBAAiB;IACnB;;IAEA,UAAU;IACV;MACE,mBAAmB;MACnB,oBAAoB;MACpB,gCAAgC;MAChC,aAAa;MACb,yBAAyB;IAC3B;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,qBAAqB;MACrB,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,cAAc;MACd,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,uBAAuB;IACzB;;IAEA;MACE,mBAAmB;MACnB,oBAAoB;MACpB,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,qBAAqB,oBAAoB,EAAE;MAC3C,eAAe,iBAAiB,EAAE;IACpC","sourcesContent":["\n    :host {\n      display: block;\n      width: 100%;\n    }\n\n    /* ══════════════════════════════════════════\n       MOBILE COMPACT BAR\n       ══════════════════════════════════════════ */\n\n    .mobile-compact-bar {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      width: 100%;\n      flex-wrap: nowrap;\n    }\n\n    /* Compact dropdowns */\n    .compact-dropdown {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n    }\n\n    .compact-dropdown .dropdown-btn {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 0.25rem;\n      font-size: 0.775rem;\n      font-weight: 500;\n      padding: 0.45rem 0.625rem;\n      border-radius: 8px;\n      border: 1.5px solid #ede9fb;\n      background: #faf8ff;\n      color: #374151;\n      white-space: nowrap;\n      transition: all 0.2s;\n      min-width: 0;\n    }\n\n    .compact-dropdown .dropdown-btn:active {\n      background: #f3eeff;\n      border-color: #c4b5fd;\n      color: #7c3aed;\n    }\n\n    .compact-dropdown .dropdown-text {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      flex: 1;\n      min-width: 0;\n    }\n\n    /* Balance chip */\n    .balance-chip {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      background: #f5f3ff;\n      border: 1.5px solid #ede9fb;\n      border-radius: 8px;\n      padding: 0.35rem 0.625rem;\n      flex-shrink: 0;\n      cursor: pointer;\n      transition: background 0.2s;\n      -webkit-tap-highlight-color: transparent;\n    }\n\n    .balance-chip:active {\n      background: #ede9fb;\n    }\n\n    .balance-chip small {\n      font-size: 0.6rem;\n      color: #7c6fa0;\n      text-transform: uppercase;\n      font-weight: 600;\n      letter-spacing: 0.4px;\n      line-height: 1;\n    }\n\n    .balance-chip span {\n      font-size: 0.82rem;\n      font-weight: 700;\n      color: #1a003d;\n      line-height: 1.35;\n    }\n\n    /* Compact top-up button */\n    .topup-btn-compact {\n      background: linear-gradient(135deg, #7c3aed, #a78bfa);\n      color: #ffffff;\n      border: none;\n      border-radius: 8px;\n      padding: 0.45rem 0.875rem;\n      font-size: 0.8rem;\n      font-weight: 600;\n      letter-spacing: 0.3px;\n      cursor: pointer;\n      flex-shrink: 0;\n      transition: opacity 0.2s, transform 0.15s;\n      -webkit-tap-highlight-color: transparent;\n      white-space: nowrap;\n    }\n\n    .topup-btn-compact:active {\n      opacity: 0.85;\n      transform: scale(0.96);\n    }\n\n    /* Shared dropdown menu */\n    .dropdown-menu-custom {\n      min-width: 180px;\n      padding: 0.5rem 0;\n      border: 1.5px solid #f0eafa;\n      box-shadow: 0 4px 16px rgba(109, 40, 217, 0.1);\n      border-radius: 10px;\n    }\n\n    .dropdown-item-custom {\n      padding: 0.625rem 1rem;\n      border: none;\n      background: none;\n      text-align: left;\n      width: 100%;\n      cursor: pointer;\n      transition: background-color 0.2s ease;\n      font-size: 0.875rem;\n      color: #374151;\n    }\n\n    .dropdown-item-custom:hover {\n      background-color: #f5f3ff;\n      color: #7c3aed;\n    }\n\n    /* ══════════════════════════════════════════\n       FULL (DESKTOP / ORIGINAL) LAYOUT\n       ══════════════════════════════════════════ */\n\n    .user-info-wrapper {\n      display: flex;\n      align-items: center;\n      width: 100%;\n    }\n\n    .user-info-container {\n      display: flex;\n      align-items: center;\n      gap: 1.25rem;\n      width: 100%;\n    }\n\n    .user-info-container.mobile-layout {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 1.5rem;\n    }\n\n    .divider {\n      width: 1px;\n      height: 32px;\n      background: #e5e7eb;\n      flex-shrink: 0;\n    }\n\n    .divider-main {\n      height: 40px;\n      background: #d1d5db;\n    }\n\n    .notification-section {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n    }\n\n    .notification-icon {\n      color: #7c3aed;\n      cursor: pointer;\n      transition: color 0.2s ease;\n    }\n\n    .notification-icon:hover {\n      color: #6d28d9;\n    }\n\n    .dropdown-section {\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n    }\n\n    .dropdown-btn {\n      padding: 0.5rem 1rem;\n      white-space: nowrap;\n      font-size: 0.875rem;\n      font-weight: 500;\n      letter-spacing: 0.3px;\n      border-radius: 8px;\n      transition: all 0.2s ease;\n    }\n\n    .balance-section {\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n    }\n\n    .balance-content {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n    }\n\n    .balance-labels {\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n    }\n\n    .balance-label {\n      font-size: 0.75rem;\n      color: #6b7280;\n      font-weight: 500;\n      letter-spacing: 0.3px;\n      text-transform: uppercase;\n    }\n\n    .balance-value {\n      font-size: 0.9rem;\n      font-weight: 600;\n      color: #1a003d;\n    }\n\n    .balance-refresh {\n      cursor: pointer;\n      font-size: 1.1rem;\n      transition: transform 0.3s ease, color 0.2s ease;\n      color: #7c3aed;\n    }\n\n    .balance-refresh:hover {\n      transform: rotate(180deg);\n      color: #6d28d9;\n    }\n\n    .credit-limit-label {\n      font-size: 0.7rem;\n      color: #f97316;\n      font-weight: 600;\n      letter-spacing: 0.2px;\n    }\n\n    .credit-label {\n      font-size: 0.55rem;\n      color: #f97316;\n      font-weight: 600;\n      letter-spacing: 0.3px;\n      line-height: 1;\n    }\n\n    .topup-section {\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n    }\n\n    .topup-btn {\n      padding: 0.5rem 1.25rem;\n      font-weight: 600;\n      font-size: 0.875rem;\n      letter-spacing: 0.3px;\n      border-radius: 8px;\n      transition: all 0.2s ease;\n    }\n\n    .topup-btn:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(124, 58, 237, 0.15);\n    }\n\n    .user-profile-section {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      flex-shrink: 0;\n      margin-left: auto;\n    }\n\n    .mobile-layout .user-profile-section {\n      margin-left: 0;\n      padding: 0.75rem;\n      background: #faf8ff;\n      border-radius: 8px;\n    }\n\n    .profile-text {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      gap: 0.25rem;\n    }\n\n    .mobile-layout .profile-text {\n      align-items: flex-start;\n    }\n\n    .profile-name {\n      font-size: 0.9rem;\n      font-weight: 600;\n      color: #1a003d;\n      letter-spacing: 0.2px;\n    }\n\n    .profile-role {\n      font-size: 0.75rem;\n      color: #9ca3af;\n      font-weight: 500;\n      text-transform: capitalize;\n    }\n\n    .mobile-menu {\n      position: absolute;\n      top: calc(100% + 8px);\n      right: 1rem;\n      padding: 1.5rem;\n      background: #ffffff;\n      border: 1.5px solid #f0eafa;\n      border-radius: 12px;\n      z-index: 1000;\n      width: calc(100% - 2rem);\n      max-width: 320px;\n      box-shadow: 0 8px 32px rgba(109, 40, 217, 0.12);\n    }\n\n    .mobile-menu-toggle {\n      padding: 0.25rem 0.5rem;\n      border: none;\n      background: transparent;\n    }\n\n    .avatar-circle {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #7c3aed 0%, #f97316 100%);\n      flex-shrink: 0;\n      box-shadow: 0 2px 8px rgba(124, 58, 237, 0.35);\n    }\n\n    .avatar-initials {\n      font-family: 'DM Sans', 'Segoe UI', sans-serif;\n      font-size: 0.8125rem;\n      font-weight: 700;\n      color: #ffffff;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n      line-height: 1;\n      user-select: none;\n    }\n\n    /* Modal */\n    .modal-header-custom {\n      background: #f5f3ff;\n      padding: 1rem 1.5rem;\n      border-bottom: 1px solid #ede9fb;\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    .modal-body-custom {\n      padding: 3rem 2rem;\n      background: #ffffff;\n    }\n\n    .modal-title {\n      font-size: 1.75rem;\n      font-weight: 700;\n      color: #2d1b69;\n      text-align: center;\n      margin-bottom: 0.5rem;\n      letter-spacing: -0.5px;\n    }\n\n    .modal-subtitle {\n      font-size: 1rem;\n      color: #7c5ba8;\n      text-align: center;\n      margin-bottom: 2rem;\n      font-weight: 500;\n    }\n\n    .modal-instructions {\n      display: flex;\n      justify-content: center;\n    }\n\n    .instructions-list {\n      list-style: decimal;\n      padding-left: 1.5rem;\n      max-width: 480px;\n      width: 100%;\n    }\n\n    .instructions-list li {\n      color: #374151;\n      margin-bottom: 1rem;\n      line-height: 1.6;\n      font-size: 0.95rem;\n    }\n\n    .instructions-list .fw-bold {\n      color: #7c3aed;\n      font-weight: 600;\n    }\n\n    @media (max-width: 768px) {\n      .modal-body-custom { padding: 2rem 1.5rem; }\n      .modal-title { font-size: 1.5rem; }\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
